module.exports = __webpack_public_path__ + "img/48.5fcd8c9e.jpg";